<template>
    <main-content style="background-color: white">
        <div class="kt-portlet z-depth-0 bg-transparent m-0">
            <div class="kt-portlet__head border-0 p-0">
                <div class="kt-portlet__head-actions" style="left: 0px; top: 10px; position: absolute;">
                    <button class="ml-2 btn btn-twitter" @click="stepBack">
                        {{ $t('label.back') }}
                        <i class="pl-2 fa fa-arrow-left"></i>
                    </button>
                </div>
            </div>
        </div>
        <kt-panel-body>
            <div class="container p-3 pt-5 my-4 border in-border-header">
                <form id="customer_detail">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('pos.stakeholder_detail') }}
                        </div>
                        <kt-row>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label
                                            v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.REAL"
                                            for="national_code">
                                        {{ $t('label.national_code') }}
                                    </kt-form-label>
                                    <kt-form-label
                                            v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                            for="national_code">
                                        {{ $t('pos.ceo_national_code') }}
                                    </kt-form-label>
                                    <span style="color: red">{{ ' *' }}</span>
                                    <kt-form-control
                                            :disabled="!$can('manage', 'pos')"
                                            type="number"
                                            dir="ltr"
                                            id="national_code"
                                            name="national_code"
                                            v-model="stakeholder_detail.customer_detail.national_code"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="!stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_crtfct_number">
                                        {{ $t('label.birth_crtfct_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="birth_crtfct_number"
                                            name="birth_crtfct_number"
                                            v-model="stakeholder_detail.customer_detail.birth_crtfct_number"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="!stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_crtfct_serial">
                                        {{ $t('label.birth_crtfct_serial') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="birth_crtfct_serial"
                                            name="birth_crtfct_serial"
                                            v-model="stakeholder_detail.customer_detail.birth_crtfct_serial"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="!stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_crtfct_series_number">
                                        {{ $t('label.birth_crtfct_series_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="birth_crtfct_series_number"
                                            name="birth_crtfct_series_number"
                                            v-model="stakeholder_detail.customer_detail.birth_crtfct_series_number"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="!stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_crtfct_series_letter">
                                        {{ $t('label.birth_crtfct_series_letter') }}
                                    </kt-form-label>
                                    <select
                                            id="birth_crtfct_series_letter"
                                            name="birth_crtfct_series_letter"
                                            v-model="stakeholder_detail.customer_detail.birth_crtfct_series_letter"
                                            class="form-control kt-selectpicker"
                                    >
                                        <option
                                                v-bind:key="birthCrtfctSeriesLetter.key"
                                                v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                                :value="birthCrtfctSeriesLetter.key"
                                        >
                                            {{ birthCrtfctSeriesLetter.value }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_date">
                                        {{ $t('label.birth_date') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="birth_date"
                                            name="birth_date"
                                            v-model="stakeholder_detail.customer_detail.birth_date" type="date"/>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-if="psp=='NOVIN'" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="customer_id">
                                        {{ $t('pos.customer_id') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            disabled
                                            type="number"
                                            dir="ltr"
                                            id="customer_id"
                                            name="customer_id"
                                            v-model="stakeholder_detail.customer_detail.customer_id"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="gender_id">
                                        {{ $t('label.gender') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <select
                                            id="gender_id"
                                            name="gender_id"
                                            v-model="stakeholder_detail.customer_detail.gender_id"
                                            class="form-control kt-selectpicker"
                                    >
                                        <option
                                                v-for="(item,index) in constants.gender" v-bind:key="index"
                                                :value="index">
                                            {{ item }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="mobile">
                                        {{ $t('pos.mobile') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>

                                    <kt-form-control
                                            dir="ltr"
                                            id="mobile"
                                            name="mobile"
                                            :disabled="!stakeholder_detail.can_change"
                                            v-model="stakeholder_detail.customer_detail.mobile"
                                            class="form-control"
                                    ></kt-form-control>
                                    <kt-form-label style="margin-top: 5px;font-size: 9px;color: red">
                                        {{ $t('pos.mobile_notification') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="first_name_fa">
                                        {{ $t('label.first_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            id="first_name_fa"
                                            name="first_name_fa"
                                            v-model="stakeholder_detail.customer_detail.first_name_fa"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="last_name_fa">
                                        {{ $t('label.last_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            id="last_name_fa"
                                            name="last_name_fa"
                                            v-model="stakeholder_detail.customer_detail.last_name_fa"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="father_name_fa">
                                        {{ $t('label.father_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            id="father_name_fa"
                                            name="father_name_fa"
                                            v-model="stakeholder_detail.customer_detail.father_name_fa"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                    lg="4"
                                    md="6"
                                    xs="12">
                                <kt-form-group>
                                    <kt-form-label for="com_name_fa">
                                        {{ $t('label.com_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            id="com_name_fa"
                                            name="com_name_fa"
                                            v-model="stakeholder_detail.customer_detail.com_name_fa"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="6" xs="12"
                                    v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL">
                                <kt-form-group>
                                    <kt-form-label for="register_date">
                                        {{ $t('label.com_register_date') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="register_date"
                                            name="register_date"
                                            v-model="stakeholder_detail.customer_detail.register_date"
                                            type="date"/>
                                </kt-form-group>
                            </kt-col>

                            <kt-col v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                    lg="4"
                                    md="6"
                                    xs="12">
                                <kt-form-group>
                                    <kt-form-label for="CompanyRegisterNo">
                                        {{ $t('pos.com_register_no') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="register_number"
                                            name="register_number"
                                            v-model="stakeholder_detail.customer_detail.register_number"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                    lg="4"
                                    md="6"
                                    xs="12">
                                <kt-form-group>
                                    <kt-form-label for="com_name_En">
                                        {{ $t('label.com_name_en') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            id="com_name_En"
                                            name="com_name_En"
                                            v-model="stakeholder_detail.customer_detail.com_name_En"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                    lg="4"
                                    md="6"
                                    xs="12">
                                <kt-form-group>
                                    <kt-form-label for="company_code">
                                        {{ $t('label.national_legal_code') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            disabled
                                            type="number"
                                            dir="ltr"
                                            id="company_code"
                                            name="company_code"
                                            v-model="stakeholder_detail.customer_detail.company_code"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="country">
                                        {{ $t('label.country_flag') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <select
                                            id="country"
                                            name="country"
                                            v-model="stakeholder_detail.customer_detail.country"
                                            class="form-control  kt-selectpicker"
                                    >
                                        <option
                                                v-for="country in constants.country"
                                                v-bind:key="country.CountryCode"
                                                :value="country.CountryCode">
                                            {{ country.CountryName }}
                                        </option>
                                    </select>
                                    <div class="my-4">
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="foreign_pervasive_code">
                                        {{ $t('pos.foreign_pervasive_code') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="foreign_pervasive_code"
                                            name="foreign_pervasive_code"
                                            v-model="stakeholder_detail.customer_detail.foreign_pervasive_code"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="passport_code">
                                        {{ $t('pos.passport_code') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            dir="ltr"
                                            id="passport_code"
                                            name="passport_code"
                                            v-model="stakeholder_detail.customer_detail.passport_code"
                                            class="form-control"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="stakeholder_detail.is_foreign" lg="4" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="passport_expire_date">
                                        {{ $t('pos.passport_credit_date') }}<span style="color: red">{{ ' *' }}</span>
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="passport_expire_date"
                                            name="passport_expire_date"
                                            v-model="stakeholder_detail.customer_detail.passport_expire_date"
                                            type="date"/>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-if="stakeholder_detail.customer_detail.customer_type_id == customerType.REAL"
                                    lg="12"
                                    md="12"
                                    xs="12">
                                <kt-form-group>

                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input"
                                               id="is_foreign_nationals"
                                               name="is_foreign_nationals"
                                               v-model="stakeholder_detail.customer_detail.is_foreign_nationals"
                                        >
                                        <label class="custom-control-label"
                                               for="is_foreign_nationals">{{
                                                $t('pos.is_foreign')
                                            }}</label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>

                        <documents v-if="psp==='NOVIN'" :parent="stakeholder_detail"></documents>

                    </kt-form-section>
                </form>
            </div>
            <div>
                <form id="account_detail">
                    <kt-form-section>
                        <div class="container p-3 pt-5 my-4 border in-border-header">
                            <div class="section-header">
                                {{ $t('pos.account_detail') }}
                            </div>
                            <kt-row style="padding-top: 35px">
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="bank_id">
                                            {{ $t('pos.bank') }}
                                            <span v-if="psp == 'NOVIN'" style="color: red">{{ ' *' }}</span>
                                        </kt-form-label>
                                        <select
                                                id="bank_id"
                                                name="bank_id"
                                                v-model="stakeholder_detail.bank_id"
                                                class="form-control kt-selectpicker"
                                        >
                                            <option
                                                    v-for="bank in constants.banks"
                                                    v-bind:key="bank.BankID"
                                                    :value="bank.BankID">
                                                {{ bank.BankName }}
                                            </option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="branch_code">
                                            {{ $t('pos.branch_code') }}<span style="color: red">{{ ' *' }}</span>
                                        </kt-form-label>
                                        <kt-form-control
                                                dir="ltr"
                                                type="number"
                                                id="branch_code"
                                                name="branch_code"
                                                v-model="stakeholder_detail.branch_code"
                                                class="form-control"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                            <kt-row>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="account_number">
                                            {{ $t('label.account_number') }}<span style="color: red">{{ ' *' }}</span>
                                        </kt-form-label>
                                        <kt-form-control
                                                dir="ltr"
                                                id="account_number"
                                                name="account_number"
                                                v-model="stakeholder_detail.account_number"
                                                class="form-control"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="sheba_number">
                                            {{ $t('label.sheba_number') }}<span style="color: red">{{ ' *' }}</span>
                                        </kt-form-label>
                                        <kt-form-label for="sheba_number">
                                            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                                <span class="tooltip-text">{{ $t('pos.btn_inquiry') }}</span>
                                                <i @click="ibanInquiry" class="fa fa-sync"
                                                   style="font-size: 14px;color: #1dc9b7; "></i>
                                            </div>
                                        </kt-form-label>
                                        <kt-form-control
                                                style="direction: ltr"
                                                id="sheba_number"
                                                name="sheba_number"
                                                v-model="stakeholder_detail.sheba_number"
                                                class="form-control transfers_destination_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                            <kt-row>
                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="sharing_percent">
                                            {{ $t('allotment.percent') }}<span style="color: red">{{ ' *' }}</span>
                                        </kt-form-label>
                                        <kt-form-control
                                                type="number"
                                                dir="ltr"
                                                id="sharing_percent"
                                                name="sharing_percent"
                                                v-model="stakeholder_detail.sharing_percent"
                                                class="form-control"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col v-if="psp=='NOVIN'" lg="6" md="6" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="customer_id">
                                            {{ $t('pos.customer_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                disabled
                                                type="number"
                                                dir="ltr"
                                                id="customer_id"
                                                name="customer_id"
                                                v-model="stakeholder_detail.customer_id"
                                                class="form-control"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col v-if="psp=='PASARGAD' && stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL"
                                        lg="12" md="12" xs="12">
                                    <kt-form-group>

                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="has_signature_holder"
                                                   name="has_signature_holder"
                                                   v-model="stakeholder_detail.has_signature_holder"
                                            >
                                            <label class="custom-control-label"
                                                   for="has_signature_holder">{{
                                                    $t('pos.has_signature_holder')
                                                }}</label>
                                        </div>
                                    </kt-form-group>

                                </kt-col>
                                <div v-show="psp=='PASARGAD'  && stakeholder_detail.customer_detail.customer_type_id == customerType.LEGAL && stakeholder_detail.has_signature_holder"
                                     class="container p-3 pt-5 my-4 border in-border-header">
                                    <div class="section-header">
                                        {{ $t('pos.signature_holders_detail') }}
                                    </div>
                                    <SignatureHolder :form_data="stakeholder_detail"></SignatureHolder>
                                </div>
                            </kt-row>
                        </div>

                    </kt-form-section>
                </form>
            </div>
            <kt-button v-if="show_detail" style="position: relative;right:75%"
                       class="m-2"
                       size="md"
                       dir="rtl"
                       @click="setAccount"
                       variant="success"
                       type="submit"
                       v-bind:wide="true"
                       id="register"
            >
                {{ $t('btn.submit_changes') }}
            </kt-button>
        </kt-panel-body>
        <kt-col lg="2" md="2" xs="4">
            <kt-form-action style=" display: none;">
                <kt-button
                        data-toggle="modal" data-target="#iban_inquiry"
                        variant="success"
                        type="submit"
                        id="iban_inquiry_fire"
                >
                </kt-button>
            </kt-form-action>
        </kt-col>
        <div id="iban_inquiry" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="iban_inquiry_title">{{ $t('pos.iban_inquiry_title') }}</div>
                        <div v-if="iban_inquiry.status == false" style=" padding-right: 20%" id="iban_inquiry_incorrect">
                            <span style="background-color:#fd397a"> {{
                                    $t('pos.message.iban_inquiry_incorrect')
                                }}</span></div>
                        <div v-if="iban_inquiry.status == true" style=" padding-right: 20%" id="iban_inquiry_correct">
                            <span style="background-color:#1dc9b7">   {{
                                    $t('pos.message.iban_inquiry_correct')
                                }}</span></div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.account_owner_fullname')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.account_owner_name }}</th>
                            </tr>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.bank')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.bank }}</th>
                            </tr>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.customer_code')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.identifier }}</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import toastr from "toastr";
import mainContent from '@/components/main-content'
import {mapGetters} from "vuex";
import {posService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app'
import {customerType, gender} from '@/constants/posNovin'
import {KTUtil} from '@/plugins/core/util'
import {MerchantDocuments} from "./index";
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter';
import IranSheba from "iran-sheba";

export default {
    name: "multi-account-edit",
    components: {
        'main-content': mainContent,
        'documents': MerchantDocuments,
    },

    data() {
        return {
            birthCrtfctSeriesLetters,
            customer_detail: {},
            show_detail: false,
            customerType,
            stakeholder_detail: {},
            iban_inquiry:{},
            images_url: {
                national_card_img: '',
                birth_certificate_card_img: '',
                national_card_behind_img: '',
                last_newspaper_img: '',
                statute_pages_img: [],
                foundation_img: '',
                passport_img: '',
                amayesh_card_img: '',
                work_permit_img: '',
                business_license_img: '',
                first_ownership_document_img: '',
                second_ownership_document_img: '',
                communicating_documents_img: '',
                license_granting_certificate_img: '',
                trust_number_img: '',
                iban_certificate: '',
                change_iban_form: '',
                installation_form: '',
                deposit_receipt: '',
                phone_bill: '',
                e_trust_certificate: '',
                card_acceptance_contract: [],
                national_card_of_second_sh: '',
                renting_or_ownership_document: '',
                delegation_of_authority_form: '',
                last_newspaper_img_introduce_sh: '',
                delegation_of_authority_national_card: '',
                birth_certificate_first_page_of_first_sh: '',
                birth_certificate_first_page_of_second_sh: '',
                certificate_form: '',
            }
        }
    },
    props: {
        wizard: {
            type: Object
        },
        reloadDataTable: {
            type: Function,
        }
    },
    methods: {
        setAccount() {
            let form = $('#customer_detail')
            let btn = $('#register')
            form.validate({
                lang: 'fa',
                rules: {
                    birth_date: {
                        required: true,
                    },
                    company_code: {
                        required: () => {
                            if (this.stakeholder_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },

                    register_date: {
                        required: () => {
                            if (this.stakeholder_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    passport_expire_date: {
                        required: () => {
                            if (this.stakeholder_detail.is_foreign) return true; else return false
                        }
                    },

                    com_name_fa: {
                        required: () => {
                            if (this.stakeholder_detail.customer_type_id == customerType.LEGAL) return true; else return false
                        }
                    },
                    customer_type_id: {
                        required: true
                    },

                    gender_id: {
                        required: true,
                    },
                    last_name_fa: {
                        required: true
                    },

                    father_name_fa: {
                        required: true,
                    },
                    first_name_fa: {
                        required: true
                    },

                    foreign_pervasive_code: {
                        required: () => {
                            if (this.stakeholder_detail.is_foreign) return true; else return false
                        }
                    },
                    passport_code: {
                        required: () => {
                            if (this.stakeholder_detail.is_foreign) return true; else return false
                        }
                    },
                    country: {
                        required: () => {
                            if (this.stakeholder_detail.is_foreign) return true; else return false
                        }
                    },
                    mobile: {
                        required: true
                    },

                    national_code: {
                        required: true,
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            let form1 = $('#account_detail')
            form1.validate({
                lang: 'fa',
                rules: {
                    bank_id: {
                        required: () => {
                            if (this.psp == 'NOVIN') return true;
                        }
                    },
                    branch_code: {
                        required: true
                    },
                    account_number: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    sharing_percent: {
                        required: true,
                        max: 100,
                        min: 0
                    },
                }
            });
            if (!form1.valid()) {
                return
            }
            let sheba = this.stakeholder_detail.sheba_number.split('_').join('')
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            this.stakeholder_detail.sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            KTApp.progress(btn)
            let stakeholder_detail = structuredClone(this.stakeholder_detail);
            delete stakeholder_detail.images_url
            delete stakeholder_detail.customer_detail

            let stakeholder_detail_data = {
                ...this.stakeholder_detail.customer_detail, ...stakeholder_detail, psp: this.psp,
                ...this.stakeholder_detail.signature_holder
            }
            posService.editStakeholder(stakeholder_detail_data).then(response => {
                this.stakeholder_detail.customer_detail.Name = this.stakeholder_detail.customer_detail.first_name_fa + this.stakeholder_detail.customer_detail.last_name_fa
                this.$store.commit('pos/editMultiAccount', this.stakeholder_detail)
                this.stepBack()
            }).catch(({response}) => {
                let message = document.createElement('div')
                message.innerHTML = response.data.message
                Object.keys(response.data.data).forEach(function (item) {
                    var li = document.createElement('li')
                    li.innerText = response.data.data[item][0]
                    message.insertAdjacentElement('beforeend', li)
                })
                KTApp.unprogress(btn)
                KTUtil.scrollTop();
                return this.showMsg(form, 'danger', message)
            })
        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('' +
                        '.transfers_destination_number'));
            }, 500)
        }
        ,
        processFile(e) {
            const name = e.target.name;
            let file = e.target.files[0];
            this.stakeholder_detail.images_url[name] = URL.createObjectURL(file);
            this.stakeholder_detail[name] = file;
        },
        processStatuteFile(e) {

            this.stakeholder_detail.images_url.statute_pages_img = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.stakeholder_detail.images_url.statute_pages_img[i] = URL.createObjectURL(file);
                this.stakeholder_detail.statute_pages_img[i] = file;
            }
        },
        initMobileMask() {
            setTimeout(() => {
                document.getElementById('mobile') && Inputmask('09999999999')
                        .mask(document.getElementById('mobile'))
            }, 500)

        }
        ,
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });
            }, 500);
        },
        ibanInquiry() {
            let sheba = this.stakeholder_detail.sheba_number
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')
            this.stakeholder_detail.sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            let params = {
                identifier: this.stakeholder_detail.customer_detail.customer_type_id == customerType.REAL ?
                        this.stakeholder_detail.customer_detail.national_code : this.stakeholder_detail.customer_detail.company_code,
                sheba_number: this.stakeholder_detail.sheba_number
            }
            posService.ibanInquiry(params).then(response => {
                this.iban_inquiry = {
                    status : response.data.data.status,
                    account_owner_name : this.stakeholder_detail.customer_detail.first_name_fa +' '+
                            this.stakeholder_detail.customer_detail.last_name_fa,
                    identifier : params.identifier,
                    bank : IranSheba.recognize(params.sheba_number)['persianName']
                }
                document.getElementById("iban_inquiry_fire").click();
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            })
        },
        stepBack() {
            window.localStorage.setItem('go', '2');
            this.goBack()
        }
    },
    mounted() {
        posService.findStakeholder(this.$route.params.hashid).then(response => {
            this.stakeholder_detail = {
                ...response.data.data, images_url: this.images_url
            }
            this.show_detail = true
        })
        this.initShebaMask();
        this.afterDispatch();
        this.initMobileMask();
    }
    ,
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'constants', 'psp'
        ])
    },
}
</script>

<style>
#app {
    text-align: right;
    color: #2c3e50;
    margin-top: 60px;
}

a,
button {
    color: #4fc08d;
}

button {
    background: none;
    border: solid 1px;
    border-radius: 2em;
    padding: 0.75em 2em;
}

.form-repeater {
    line-height: 20px;
    margin-bottom: 20px;
}

.form {
    padding: 20px;
    border: 1px solid #000;
    border-radius: 20px;
}
</style>